import React, { useContext } from 'react';
import { L as Logo } from './Logo-fy1HhiD6.js';
import { P as PageMaintinence } from './PageMaintenance-iWNOIvs_.js';
import './utils/logToSlack.js';
import { logErrorToRelic } from './utils/logToRelic.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import './utils/currency.js';
import { CoreContext } from './context/index.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import 'next/router';
import './helpers-qU2Vf3ni.js';
import 'lodash';
import { P as PageOops } from './PageOops-RkvH4FWA.js';

const getContext = () => {
    const { data: { siteConfig: { LOGO_IMAGE }, }, } = useContext(CoreContext);
    return LOGO_IMAGE;
};
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error: error.message };
    }
    componentDidCatch(error, errorInfo) {
        logErrorToRelic(error);
        // Show the error to console
        // eslint-disable-next-line no-console
        console.error(error, errorInfo);
    }
    render() {
        const { LOGO_IMAGE, highLevel = false, children } = this.props;
        const { error } = this.state;
        const isDevelopment = process.env.NODE_ENV === 'development';
        // No error. Render a children
        if (!error)
            return children;
        // Error. "development" mode. Render <PageOops />
        if (isDevelopment)
            return React.createElement(PageOops, null);
        // Error. "production" mode. Render <PageMaintenance />
        return (React.createElement(React.Fragment, null,
            highLevel && (React.createElement("header", { className: "header-maintenance" },
                React.createElement("div", { className: "header-wrap" },
                    React.createElement(Logo, { url: "/", img: LOGO_IMAGE })))),
            React.createElement(PageMaintinence, null)));
    }
}
const ErrorBoundaryWithLogo = ({ children, highLevel }) => {
    const LOGO_IMAGE = getContext();
    return (React.createElement(ErrorBoundary, { highLevel: highLevel, LOGO_IMAGE: LOGO_IMAGE }, children));
};

export { ErrorBoundaryWithLogo as E };
//# sourceMappingURL=ErrorBoundary-fTdPPYbd.js.map
